<button *ngIf="!showFilterForm && editable" class="btn btn-info" (click)="showFilterForm = true">Add
    #{{deviceParamLirisV3FilterArray.length}}
</button>
<div *ngIf="showFilterForm && editable" class="edit-container-params">
    <h4>{{currentFilterIndexForEdition !== null ? 'Edit ' : 'Add ' }} {{modeName.toLowerCase()}}
        #{{currentFilterIndexForEdition
        !== null ? currentFilterIndexForEdition : deviceParamLirisV3FilterArray.length }}
    </h4>
    <form [formGroup]="filterForm">
        <mat-form-field>
            <mat-select placeholder="{{'CHANNEL'|translate}}" formControlName="channel" [disabled]="!openChannelSelection">
                <mat-option [value]="0">{{'CHANNEL'|translate}} 1</mat-option>
                <mat-option [value]="1">{{'CHANNEL'|translate}} 2</mat-option>
            </mat-select>
        </mat-form-field>


        <mat-form-field>
            <input matInput placeholder="T0 (ms)" formControlName="t0" required type="number">
        </mat-form-field>

        <mat-slide-toggle formControlName="activated">
            {{filterForm.value.activated ? ('ACTIVE' | translate) :
            ('INACTIVE' | translate)}}
        </mat-slide-toggle>
        <button class="btn btn-danger btn-float-right" (click)="cancelFilter()">
            Cancel
        </button>
        <button class="btn btn-success btn-float-right" *ngIf="currentFilterIndexForEdition !== null"
                (click)="editFilter()">Edit
            #{{currentFilterIndexForEdition}}
        </button>
        <button class="btn btn-info btn-float-right" *ngIf="currentFilterIndexForEdition === null"
                (click)="addFilter()">Add

        </button>
    </form>
</div>
<div *ngFor="let filter of deviceParamLirisV3FilterArray;let i = index">
    <div *ngIf="currentFilterIndexForEdition === null" class="read-container-params">
        <h4> {{modeName}}#{{i}}</h4>
        <form>
            <mat-form-field>
                <mat-select placeholder="{{'CHANNEL'|translate}}" [value]="deviceParamLirisV3FilterArray[i].channel"
                            [disabled]="true">
                    <mat-option [value]="0">{{'CHANNEL'|translate}} 1</mat-option>
                    <mat-option [value]="1">{{'CHANNEL'|translate}} 2</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="T0 (ms)" [value]="deviceParamLirisV3FilterArray[i].t0"
                       [readonly]="true"
                       type="number">
            </mat-form-field>

            <mat-slide-toggle [(ngModel)]="deviceParamLirisV3FilterArray[i].activated"
                              [ngModelOptions]="{standalone: true}"
                              [disabled]="true">
                {{deviceParamLirisV3FilterArray[i].activated ? ('ACTIVE' | translate) :
                ('INACTIVE' | translate)}}
            </mat-slide-toggle>
            <button class="btn btn-danger btn-float-right" *ngIf="currentFilterIndexForEdition !== i && editable"
                    (click)="removeFilter(i)">
                {{'DELETE'|translate}}
            </button>
            <button class="btn btn-success btn-float-right" *ngIf="currentFilterIndexForEdition !== i && editable"
                    (click)="setFormWithFilter(i)">{{'EDIT'|translate}}
                #{{i}}
            </button>
        </form>
    </div>
</div>
